<style lang="less">
@import './login.less';
</style>

<template>
  <div class="login">
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  methods: {
    ...mapActions(['getUserInfo']),
  },
  created() {
    const token = this.$route.query.token;
    if (token) {
      // 提交 token 到 Vuex store
      this.$store.commit('setToken', token);

      // 获取用户信息并重定向
      this.getUserInfo().then(res => {
        this.$router.push({
          name: 'zhiweiIndex'
        });
      }).catch(err => {
        console.error('Failed to get user info:', err);
        // 可以根据需要处理错误，例如显示错误消息或重定向到登录页面
      });
    } else {
      console.error('Token is missing in URL');
      // 处理缺少 token 的情况，例如重定向到登录页面
      this.$router.push({
        name: 'login'
      });
    }
  }
};
</script>
